import Vue from 'vue'
import Vuex from 'vuex'
import { loginApi, fetchProfileApi } from '@/api/auth'

Vue.use(Vuex)

const TOKEN_KEY = 'admin_token'
const USER_KEY = 'admin_user'

export default new Vuex.Store({
  state: {
    token: localStorage.getItem(TOKEN_KEY) || '',
    user: JSON.parse(localStorage.getItem(USER_KEY) || 'null')
  },
  getters: {
    isLoggedIn: (state) => !!state.token,
    username: (state) => (state.user && (state.user.displayName || state.user.username)) || '',
    role: (state) => (state.user && state.user.role) || ''
  },
  mutations: {
    SET_AUTH(state, { token, user }) {
      state.token = token
      state.user = user
      localStorage.setItem(TOKEN_KEY, token)
      localStorage.setItem(USER_KEY, JSON.stringify(user))
    },
    SET_USER(state, user) {
      state.user = user
      localStorage.setItem(USER_KEY, JSON.stringify(user))
    },
    CLEAR_AUTH(state) {
      state.token = ''
      state.user = null
      localStorage.removeItem(TOKEN_KEY)
      localStorage.removeItem(USER_KEY)
    }
  },
  actions: {
    async login({ commit }, payload) {
      const res = await loginApi(payload)
      const { token, user } = res.data
      commit('SET_AUTH', { token, user })
      return user
    },
    async fetchProfile({ commit }) {
      const res = await fetchProfileApi()
      commit('SET_USER', res.data)
      return res.data
    },
    logout({ commit }) {
      commit('CLEAR_AUTH')
    }
  }
})
